import { ArrowUpRight, Sparkles } from 'lucide-react';
import { Button } from '@/components/ui';
import type { OkdocPatientPortalConfig } from '@/features/okdoc/config';

interface PatientPortalCardProps {
  portal: OkdocPatientPortalConfig;
  headerClassName: string;
  accentClassName: string;
  buttonClassName: string;
}

export function PatientPortalCard({ portal, headerClassName, accentClassName, buttonClassName }: PatientPortalCardProps) {
  return (
    <div className="mt-6 overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-[0_24px_60px_-36px_rgba(15,23,42,0.35)]">
      <div className={`px-5 py-4 text-white ${headerClassName}`}>
        <div className="flex items-center gap-2 text-sm font-medium">
          <Sparkles className="h-4 w-4" />
          Еще больше полезного
        </div>
      </div>
      <div className="space-y-4 p-5 sm:p-6">
        <div>
          <h3 className="text-lg font-semibold text-slate-900">{portal.title}</h3>
          <p className="mt-2 text-sm leading-6 text-slate-600">{portal.description}</p>
        </div>

        <div className={`text-sm font-medium ${accentClassName}`}>Доступно сразу после перехода по ссылке</div>

        <div className="space-y-3">
          <Button
            className={`w-full rounded-2xl px-5 py-3 text-base shadow-sm ${buttonClassName}`}
            onClick={() => window.open(portal.url, '_blank', 'noopener,noreferrer')}
          >
            {portal.buttonLabel}
            <ArrowUpRight className="ml-2 h-4 w-4" />
          </Button>
          {(portal.extraActions || []).map((action) => (
            <Button
              key={action.url}
              className="w-full rounded-2xl border border-slate-200 bg-white px-5 py-3 text-base text-slate-800 shadow-sm hover:bg-slate-50"
              variant="secondary"
              onClick={() => window.open(action.url, '_blank', 'noopener,noreferrer')}
            >
              {action.label}
              <ArrowUpRight className="ml-2 h-4 w-4" />
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
}
